.input--search[disabled] {
  opacity: 1;
}
